import { forwardRef } from "react";
import styles from "./notification.module.scss";
import { Close } from "@rsuite/icons";
import { Animation } from "rsuite";

type notificationProps = {
  success: boolean;
  notificationShow: boolean;
  handleNotificationClose: () => void;
  message: string;
};

const NotificationComponent = ({
  success,
  notificationShow,
  handleNotificationClose,
  message,
}: notificationProps) => {
  const NotificationType = forwardRef<HTMLElement>(({ ...props }, ref) => (
    <aside {...props} ref={ref}>
      <div
        className={`${success ? styles.bgSuccess : styles.bgFailure} ${
          styles.notification
        } d-flex justify-content-center shadow rounded p-3 ms-auto position-relative`}
      >
        <p className="px-2 my-auto fs-6">{message}</p>

        <Close
          onClick={() => handleNotificationClose()}
          className={styles.closeIcon}
        />
      </div>
    </aside>
  ));

  return (
    <Animation.Slide
      className={`${styles.notificationWrapper}`}
      in={notificationShow}
      placement={`right`}
    >
      {notificationShow ? (
        (props, ref) => <NotificationType {...props} ref={ref} />
      ) : (
        <div></div>
      )}
    </Animation.Slide>
  );
};

export default NotificationComponent;
